import React, { ReactElement } from 'react';

import { Layout } from '@components/atoms';
import { useReduxForm } from '@hooks/useReduxForm';

function B2CForm(): ReactElement {
  const {
    formData = {
      name: undefined,
      gender: undefined,
      age: undefined,
    },
    setFormData,
  } = useReduxForm('b2cform');
  const { setFormData: setR2CResultFormData } = useReduxForm('b2cResult');

  return (
    <Layout yzTypeLayout="SURVEY">
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          paddingTop: '25px',
          rowGap: '25px',
        }}
      >
        <span
          style={{
            fontSize: '24px',
            lineHeight: '1.2em',
            color: '#1d1c1d',
            letterSpacing: '-0.24px',
            fontWeight: 700,
            whiteSpace: 'pre-wrap',
            textAlign: 'center',
          }}
        >
          {`설문 문항 구성을 위해
아래의 정보를 입력해주세요.`}
        </span>
        <span
          style={{
            marginTop: '-20px',
            color: '#afafaf',
            fontSize: '15px',
            lineHeight: '1.4em',
            letterSpacing: '-0.15px',
            textAlign: 'center',
          }}
        >
          입력하신 개인 정보는 저장되지 않습니다.
        </span>
        <div
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            rowGap: '10px',
          }}
        >
          <span
            style={{
              fontSize: '20px',
              lineHeight: '1.2em',
              color: '#1d1c1d',
              letterSpacing: '-0.8px',
              fontWeight: 700,
              whiteSpace: 'nowrap',
            }}
          >
            이름
          </span>
          <input
            onChange={(e) => {
              setFormData({ ...formData, name: e.target.value });
            }}
            // placeholder="이름을 입력해 주세요."
            style={{
              width: '100%',
              height: '52px',
              border: '1px solid #cfcfcf',
              borderRadius: '20px',
              background: '#ffffff',
              fontSize: '20px',
              lineHeight: '1.8em',
              color: '#1d1c1d',
              padding: '0 20px',
            }}
            type="text"
            value={formData?.name}
          />
        </div>
        <div
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            rowGap: '10px',
          }}
        >
          <span
            style={{
              fontSize: '20px',
              lineHeight: '1.2em',
              color: '#1d1c1d',
              letterSpacing: '-0.8px',
              fontWeight: 700,
              whiteSpace: 'nowrap',
            }}
          >
            성별
          </span>
          <div
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              columnGap: '10px',
            }}
          >
            {[
              { label: '여자', value: 'FEMALE' },
              {
                label: '남자',
                value: 'MALE',
              },
            ].map(({ label, value }) => {
              const checked = formData?.gender === value;
              return (
                <button
                  onClick={() => {
                    setFormData({ ...formData, gender: value });
                  }}
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '98px',
                    height: '52px',
                    border: `1px solid ${checked ? '#C2D5EB' : '#cfcfcf'}`,
                    borderRadius: '20px',
                    background: checked ? '#D4E8FF' : '#ffffff',
                  }}
                  type="button"
                >
                  <span
                    style={{
                      color: '#1d1c1d',
                      fontSize: '20px',
                      lineHeight: '1.8em',
                      marginTop: '2px',
                    }}
                  >
                    {label}
                  </span>
                </button>
              );
            })}
          </div>
        </div>
        <div
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            rowGap: '10px',
          }}
        >
          <span
            style={{
              fontSize: '20px',
              lineHeight: '1.2em',
              color: '#1d1c1d',
              letterSpacing: '-0.8px',
              fontWeight: 700,
              whiteSpace: 'nowrap',
            }}
          >
            나이
          </span>
          <div
            style={{
              width: '100%',
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              columnGap: '10px',
              rowGap: '13px',
            }}
          >
            {[
              { label: '10 미만', value: 0 },
              {
                label: '10대',
                value: 10,
              },
              {
                label: '20대',
                value: 20,
              },
              {
                label: '30대',
                value: 30,
              },
              {
                label: '40대',
                value: 40,
              },
              {
                label: '50대',
                value: 50,
              },
              {
                label: '60 이상',
                value: 60,
              },
            ].map(({ label, value }) => {
              const checked = formData?.age === value;
              return (
                <button
                  onClick={() => {
                    setFormData({ ...formData, age: value });
                    setR2CResultFormData({ b2cResultCode: undefined });
                  }}
                  style={{
                    flex: '0 0 98px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '87px',
                    height: '52px',
                    border: `1px solid ${checked ? '#C2D5EB' : '#cfcfcf'}`,
                    borderRadius: '20px',
                    background: checked ? '#D4E8FF' : '#ffffff',
                  }}
                  type="button"
                >
                  <span
                    style={{
                      color: '#1d1c1d',
                      fontSize: '20px',
                      lineHeight: '1.8em',
                      letterSpacing: '-0.8px',
                      marginTop: '2px',
                    }}
                  >
                    {label}
                  </span>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default B2CForm;
